import config from "src/config";
import { BomDto, BomModalDto, BomParentModalDto } from "src/dtos/bom/BomDto";
import { ResponseDto } from "src/dtos/common/responseDto";
import { ItemDto } from "src/dtos/item/itemDto";
import { WmsStockLotDto } from "src/dtos/wmsLot/wmsStockLotDto";
import { getData } from "src/utils/axios/serverHelper";

const lotUrl = `${config.apiUrl}/lot`;

export const getLotSearchList = async (searchText: string, workplaceCd: string, itemCd: string) => {

	const url = `${lotUrl}/modal`;

	return await getData<ResponseDto<WmsStockLotDto[]>>(url, {
		params: {
			searchText,
			workplaceCd: workplaceCd || "all",
			itemCd: itemCd || ""
		}
	})
}